import { render, staticRenderFns } from "./ProductFormOther.pug?vue&type=template&id=7c1b8624&lang=pug&"
import script from "./ProductFormOther.vue?vue&type=script&lang=js&"
export * from "./ProductFormOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports